import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import ScheduleDelivery from "../components/scheduleDelivery/ScheduleDelivery";

export default function ScheduleDeliveryView() {
  return (
    <div className="pageWrapper">
      <Header title="Bezorging Inplannen" />
      <div className="contentWrapper fadeInDelayed">
        <ScheduleDelivery />
      </div>
      <BottomNavBar />
    </div>
  );
}
